/**
 * Amino acids commonly discussed in sea moss education materials.
 * Blurbs are claim-safe educational framing — not medical promises or jar-specific assays.
 */
export const SEA_MOSS_AMINO_ACIDS_INTRO =
  "Sea moss is often discussed for a range of amino acids — the building blocks of proteins. Below is a commonly cited educational list associated with sea moss nutrition conversations.";

export const SEA_MOSS_AMINO_ACIDS_VARIABILITY_NOTE =
  "Exact amino acid content can vary by algae species and growing conditions. Lists like this are for general education, not a guarantee of amounts in every jar or serving.";

export const SEA_MOSS_AMINO_ACIDS = [
  {
    name: "Alanine",
    blurb: "Commonly discussed in relation to energy metabolism and everyday protein turnover.",
  },
  {
    name: "Arginine",
    blurb: "Often associated with nitric oxide pathways involved in blood-vessel tone and circulation topics in nutrition education.",
  },
  {
    name: "Asparagine",
    blurb: "Frequently mentioned alongside nervous-system biochemistry and the making of other amino acids.",
  },
  {
    name: "Aspartic acid",
    blurb: "Commonly discussed for roles in nervous-system pathways and amino-acid synthesis.",
  },
  {
    name: "Cysteine",
    blurb: "Often linked in education materials to antioxidant chemistry and sulphur-containing pathways.",
  },
  {
    name: "Glutamic acid",
    blurb: "Widely discussed for nervous-system signalling and as a building block for other amino acids.",
  },
  {
    name: "Glycine",
    blurb: "Commonly associated with collagen structure and general protein-building conversations.",
  },
  {
    name: "Histidine",
    blurb: "Often cited in growth-and-development nutrition education and acid–base balance discussions.",
  },
  {
    name: "Isoleucine",
    blurb: "A branched-chain amino acid frequently discussed for muscle protein turnover and energy metabolism.",
  },
  {
    name: "Leucine",
    blurb: "A branched-chain amino acid commonly discussed for muscle protein turnover and energy metabolism.",
  },
  {
    name: "Lysine",
    blurb: "Often mentioned in education around growth, enzymes, and hormone-related protein pathways.",
  },
  {
    name: "Methionine",
    blurb: "Commonly discussed with antioxidant-related pathways and fat metabolism topics.",
  },
  {
    name: "Phenylalanine",
    blurb: "Frequently associated with pathways that produce signalling molecules such as dopamine and adrenaline.",
  },
  {
    name: "Proline",
    blurb: "Commonly linked to collagen structure and general protein-building discussions.",
  },
  {
    name: "Serine",
    blurb: "Often discussed for protein synthesis and nervous-system biochemistry.",
  },
  {
    name: "Threonine",
    blurb: "Frequently mentioned in immune-related protein and antibody education contexts.",
  },
  {
    name: "Tryptophan",
    blurb: "Commonly associated with pathways that produce serotonin and melatonin — topics often discussed for mood and sleep routines.",
  },
  {
    name: "Tyrosine",
    blurb: "Often linked to pathways that produce signalling molecules such as dopamine and adrenaline.",
  },
  {
    name: "Valine",
    blurb: "A branched-chain amino acid frequently discussed for muscle protein turnover and energy metabolism.",
  },
];
